import { Button, Css, Tooltip, useComputed } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { ReactNode } from "react";
import { SelectConfigurationStep_StructureFragment } from "../1.SelectConfigurationStep.generated";
import { ApplyConfigurationFormInput } from "../initial/applyInitialConfigurationWorkflow";
import { ApplyConfigurationCard } from "./ApplyConfigurationCard";
import { NoConfigurationEmptyState } from "./NoConfigurationEmptyState";

type ConfigurationChangeSectionProps = {
  formState: ObjectState<ApplyConfigurationFormInput>;
  structure: SelectConfigurationStep_StructureFragment;
};

export function ConfigurationChangeSection(props: ConfigurationChangeSectionProps) {
  const { formState, structure } = props;
  const { readyPlanConfig } = structure;
  const hasReplacement = useComputed(() => !!formState.selectedConfigId.value, [formState]);
  if (!readyPlanConfig && !hasReplacement) return <NoConfigurationEmptyState />;
  return (
    <div css={Css.df.gap3.mb3.$}>
      <ConfigurationPanel title="Original">
        {readyPlanConfig ? (
          <ApplyConfigurationCard
            readyPlanConfig={readyPlanConfig}
            aggregateVersion={readyPlanConfig.aggregateVersion ?? undefined}
          />
        ) : (
          <NoConfigurationEmptyState compact />
        )}
      </ConfigurationPanel>
      <ConfigurationPanel title="New">
        <ChooseReplacementButton formState={formState} />
        {/* todo branch existing selected replacement configuration */}
      </ConfigurationPanel>
    </div>
  );
}

function ConfigurationPanel(props: { title: string; children: ReactNode }) {
  const { title, children } = props;
  return (
    <div css={Css.df.fdc.gap2.fb0.fg1.$}>
      <span css={Css.mdSb.$}>{title}</span>
      <div css={Css.df.fg1.$}>{children}</div>
    </div>
  );
}

function ChooseReplacementButton(props: { formState: ObjectState<ApplyConfigurationFormInput> }) {
  const { formState } = props;
  const disabled = useComputed(() => !formState.selectedConfigType.value, [formState]);
  return (
    <div css={Css.df.aic.jcc.w100.ba.bcGray300.br8.bgWhite.p3.$}>
      <Tooltip title="Select the configuration to apply to this structure">
        <Button label="Choose Replacement" variant="secondary" disabled={disabled} onClick={() => {}} />
      </Tooltip>
    </div>
  );
}
